import { useState } from 'react';
import { createFilter } from './BaseFilter';

import React from 'react';
import { Range } from 'react-range';

export const createRangeFilter = ({ field, label, min, max }) => {
    return createFilter({
        type: 'range',
        field,
        label,

        getInitialState: () => ({
            value: [min, max],
            isActive: false
        }),

        applyFilter: (data, currentValue) => {
            if (!currentValue || !Array.isArray(currentValue)) return data;
            const [minVal, maxVal] = currentValue;

            return data.filter(item => {
                const value = item[field];
                return value >= minVal && value <= maxVal;
            });
        },

        renderFilter: ({ value, onChange }) => {
            return (
                <div style={{ minWidth: '250px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <label className="form-label mb-2">{label}</label>
                    <div style={{ padding: '0 10px' }}>
                        <Range
                            step={1}
                            min={min}
                            max={max}
                            values={value}
                            onChange={onChange}
                            renderTrack={({ props, children }) => {
                                const { key, ...trackProps } = props;
                                return (
                                    <div
                                        key={key}
                                        {...trackProps}
                                        style={{
                                            ...trackProps.style,
                                            height: '6px',
                                            width: '100%',
                                            backgroundColor: '#eee',
                                            borderRadius: '3px'
                                        }}
                                    >
                                        {children}
                                    </div>
                                );
                            }}
                            renderThumb={({ props }) => {
                                const { key, ...thumbProps } = props;
                                return (
                                    <div
                                        key={key}
                                        {...thumbProps}
                                        style={{
                                            ...thumbProps.style,
                                            height: '20px',
                                            width: '20px',
                                            backgroundColor: '#007bff',
                                            borderRadius: '50%',
                                            border: '2px solid white',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                        }}
                                    />
                                );
                            }}
                        />
                        <div className="d-flex justify-content-between mt-2">
                            <small className="text-muted">{value[0]}</small>
                            <small className="text-muted">{value[1]}</small>
                        </div>
                    </div>
                </div>
            );
        },

        reset: () => [min, max]
    });
};
